// import "../css/styles.css";

// Modules
// ---------------------------------
import Accordion from "./accordion";
import Analytics from "./analytics";
import OkendoIntercom from "./intercom";
import Steps from "./steps";
import Tilt from "./tilt";
// import UTM from "./utm";
import Anchor from "./anchor";
import Modal from "./modal";

// Components
// ---------------------------------
import AccordionContent from "../../components/accordion-content";
import Animations from "../../components/animation";
import ArticleListing from "../../components/article-listing";
import BecomePartnerForm from "../../components/become-partner-form";
import BookDemo from "../../components/book-demo";
import BookDemoForm from "../../components/book-demo-form";
import BookNowForm from "../../components/book-now-form";
import Callouts from "../../components/callouts";
import CarouselContent from "../../components/carousel-content";
import CaseStudiesListing from "../../components/case-studies-listing";
import ClientTestimonialGrid from "../../components/client-testimonials-grid";
import Countdown from "../../components/_single/countdown";
import CustomerImpact from "../../components/customer-impact";
import CustomerStoryVideos from "../../components/customer-story-videos";
import FeaturedMerchants from "../../components/featured-merchants";
import Hamburger from "../../components/hamburger";
import HiringProcess from "../../components/hiring-process";
import HomeHeroV2 from "../../components/home-hero-v2";
import InspirationListing from "../../components/inspiration-listing";
import JoinUs from "../../components/join-us";
import LandingPageHero from "../../components/landing-page-hero";
import LogoTicker from "../../components/logo-ticker";
import MobileMenu from "../../components/mobile-menu";
import PartnerBenefits from "../../components/partner-benefits";
import PartnershipSpotlight from "../../components/partnership-spotlight";
import PlatformAdvantages from "../../components/platform-advantages";
import Pricing from "../../components/pricing";
import ProductDemo from "../../components/product-demo";
import ProductFeaturedIntegrations from "../../components/product-featured-integrations";
import ProductHero from "../../components/product-hero";
import ProductImageGallery from "../../components/product-image-gallery";
import ProductUpdatesHighlights from "../../components/product-updates-highlights";
import ProductUpdatesAll from "../../components/product-updates-all";
import RelatedCustomerStories from "../../components/related-customer-stories";
import ResourcesCarousel from "../../components/resources-carousel";
import SocialProof from "../../components/social-proof";
import EngineeredForPerformance from "../../components/engineered-for-performance";
import TabbedContent from "../../components/tabbed-content";
import TimelineCarousel from "../../components/timeline";
import WatchOurDemos from "../../components/watch-our-demos";
import WebinarsCarousel from "../../components/webinars-carousel";
import WhatsNew from "../../components/whats-new";
import WYSIWYG from "../../components/wysiwyg";
import HeroVideoInline from "../../components/yotpo-landing-page/hero-video-inline";
import VideoTestimonials from "../../components/yotpo-landing-page/video-testimonials";
import KeyTakeaways from "../../components/longform/key-takeaways";

// Loyalty Components
import LoyaltyHero from "../../components/loyalty-hero";
import LoyaltyDisplays from "../../components/loyalty-displays";
import LoyaltyEarningRules from "../../components/loyalty-earning-rules";
import LoyaltyFeatures from "../../components/loyalty-features";
import LoyaltyLandingPage from "../../components/loyalty-landing-page";
import LoyaltyOnSite from "../../components/loyalty-on-site";
import LoyaltyRedemptionRules from "../../components/loyalty-redemption-rules";
import LoyaltyReporting from "../../components/loyalty-reporting";
import LoyaltyVIPTiers from "../../components/loyalty-vip-tiers";

// Loyalty v2 Components
import LoyaltySlideshow from "../../components/loyalty/loyalty-slideshow";

// Helpers
// ---------------------------------
import { detectIE, enableJS } from "./utils";
import CampaignQuotes from "../../components/yotpo-landing-page/campaign-quotes";
import Horizontal from "../../components/longform/horizontal";
import LongformContent from "../../components/longform/content";
import InspirationGallery from "../../components/longform/inspiration-gallery";
import StepperStickyNav from "../../components/longform/stepper-sticky-nav";
import Stats from "../../components/longform/stats";
import TextCalloutSections from "../../components/quarterly-releases/text-callout-sections";
import ProductFeaturedImage from "../../components/quarterly-releases/product-featured-image";

/**
 * @class App
 * A basic class to hold instances of modules
 * Any other global config can be setup here
 */
class App {
  constructor() {
    // Helpers
    // ---------------------------------
    detectIE();
    enableJS();

    // Modules
    // ---------------------------------
    new Accordion();
    new Analytics();
    new OkendoIntercom();
    new Tilt();
    // new UTM();
    new Anchor();
    new Modal();

    // Components
    // ---------------------------------
    new AccordionContent();
    new Animations();
    new ArticleListing();
    new BecomePartnerForm();
    new BookDemo();
    new BookDemoForm();
    new BookNowForm();
    new Callouts();
    new CarouselContent();
    new CaseStudiesListing();
    new ClientTestimonialGrid();
    new Countdown();
    new CustomerImpact();
    new CustomerStoryVideos();
    new FeaturedMerchants();
    new Hamburger();
    new HiringProcess();
    new HomeHeroV2();
    new InspirationListing();
    new JoinUs();
    new LandingPageHero();
    new LogoTicker();
    new MobileMenu();
    new PartnerBenefits();
    new PartnershipSpotlight();
    new PlatformAdvantages();
    new Pricing();
    new ProductDemo();
    new ProductFeaturedIntegrations();
    new ProductHero();
    new ProductImageGallery();
    new ProductUpdatesHighlights();
    new ProductUpdatesAll();
    new RelatedCustomerStories();
    new ResourcesCarousel();
    new SocialProof();
    new EngineeredForPerformance();
    new Steps();
    new TabbedContent();
    new TimelineCarousel();
    new WatchOurDemos();
    new WebinarsCarousel();
    new WhatsNew();
    new WYSIWYG();
    new HeroVideoInline();
    new VideoTestimonials();
    new CampaignQuotes();
    new KeyTakeaways();
    new Horizontal();
    new LongformContent();
    new InspirationGallery();
    new StepperStickyNav();
    new Stats();
    new TextCalloutSections();
    new ProductFeaturedImage();

    // Loyalty Components
    // ---------------------------------
    new LoyaltyHero();
    new LoyaltyDisplays();
    new LoyaltyEarningRules();
    new LoyaltyFeatures();
    new LoyaltyLandingPage();
    new LoyaltyOnSite();
    new LoyaltyRedemptionRules();
    new LoyaltyReporting();
    new LoyaltyVIPTiers();

    // Loyalty v2 Components
    // ---------------------------------
    new LoyaltySlideshow();
  }
}

// Ready
// ---------------------------------
document.addEventListener("DOMContentLoaded", () => new App());
